import { Typo } from '@curry-group/mui-curcuma';
import { faHourglassClock } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Badge from '@material-ui/core/Badge';
import { GeneralUserStatus } from '../../model/ryve/Thing';

export type IAvatarWithBadgeProps = {
    avatar: React.ReactElement;
    userStatus?: string;
    variant?: 'dot' | 'standard';
};

export const AvatarWithBadge: React.FunctionComponent<IAvatarWithBadgeProps> = ({
  avatar,
  userStatus,
  variant
}) => {
    return !userStatus || (userStatus !== GeneralUserStatus.CheckSignature && userStatus !== GeneralUserStatus.Expert)
        ? avatar
        : userStatus === GeneralUserStatus.Expert
          ? <Badge
              overlap="circular"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              color={'secondary'}
              title={'Experte/Expertin'}
              badgeContent={<Typo variant={'body2'} style={{fontSize: '.925em'}} fontWeight={400}>E</Typo>}
              variant={variant ?? 'standard'}
            >
              {avatar}
            </Badge>
          : <Badge
              overlap="circular"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              color={'error'}
              title={'User noch nicht validiert.'}
              badgeContent={<FontAwesomeIcon icon={faHourglassClock} />}
              variant={variant ?? 'standard'}
            >
              {avatar}
            </Badge>;
}